export { default as SectionBox } from "./SectionBox";
export { default as SelectBox } from "./SelectBox";
export { default as ToggleSwitch } from "./ToggleSwitch";

export const inputCls = "tw-w-full tw-px-3 tw-py-2 tw-border tw-border-gray-200 tw-rounded-lg tw-text-sm focus:tw-outline-none focus:tw-border-blue-400";
export const inputSmCls = "tw-px-3 tw-py-2 tw-border tw-border-gray-200 tw-rounded-lg tw-text-sm focus:tw-outline-none focus:tw-border-blue-400";
